import React, { useState } from 'react';
import { ButtonHLPure, InputHLPure, TextAreaHLPure } from '../../pures';
import { useTranslation } from "react-i18next";
import { useEffect } from 'react';
import { Container, Grid } from '@material-ui/core';

const ConfigurationDomainsAddDomainView = (props) => {
    let {
        backGrid,
        action,
        createDomain,
        selectedDomain,
        editDomain,
        toggleDialogDeleteDomain
    } = props

    const { t } = useTranslation();
    const { t: tCommon } = useTranslation('common');

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [updatedByLabel, setUpdatedByLabel] = useState('')
    const [nameDisable, setNameDisable] = useState(false)

    useEffect(() => {
        if (action !== tCommon('details') || !selectedDomain) return;
        const modifiedBy = selectedDomain.updatedByUser ? `por ${selectedDomain.updatedByUser}` : '';
        const modifiedDate = selectedDomain.updatedDate ? `el ${selectedDomain.updatedDate}` : '';
        let labelUpdatedBy = `Modificado ${modifiedBy} ${modifiedDate}`
        setUpdatedByLabel(labelUpdatedBy)
    }, [selectedDomain, t, tCommon, action]);

    // Efecto solo para inicializar valores
    useEffect(() => {
        if (action !== tCommon('details') || !selectedDomain) return;
        setName(selectedDomain.name);
        setDescription(selectedDomain.description);
        setNameDisable(!!selectedDomain.signers);
    }, [selectedDomain, action, tCommon]);

    const handleChangeName = (e) => {
        setName(e.target.value)
    }

    const handleDescription = (e) => {
        setDescription(e.target.value)
    }

    const handleSubmit = () => {
        let data = {}
        data.name = name
        data.description = description
        if (action === t("configurationDomainView.newDomain")) {
            createDomain(data)
        } else {
            data.id = selectedDomain.id
            data.clientId = selectedDomain.clientId
            editDomain(data)
        }
    }

    return (
        <Container disableGutters maxWidth="md">
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <InputHLPure
                        labelInput={t("configurationDomainsAddDomainView.name")}
                        typeInput={"text"}
                        valueInput={name}
                        tooltipShow
                        positionTooltip={"right"}
                        titleTooltip={t("configurationDomainsAddDomainView.name")}
                        descriptionTooltip={t("configurationDomainsAddDomainView.name.tooltip")}
                        handleChangeInput={(e) => handleChangeName(e)}
                        informationIcon={true}
                        inputActive={true}
                        disabled={nameDisable ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextAreaHLPure
                        labelTextArea={t("configurationDomainsAddDomainView.description")}
                        valueTextData={description}
                        positionTooltip={"right"}
                        handleChangeTextArea={(e) => handleDescription(e)}
                    />
                </Grid>
                {
                    action === tCommon('details') &&
                    <Grid item xs={12} className='configurationDomainsAddDomain-container-label-updatedBy'>
                        <span>{updatedByLabel}</span>
                    </Grid>
                }
                <Grid item xs={12} className='button-actions'>
                    <ButtonHLPure
                        nameBtn={t("button.cancel")}
                        outlined colorScheme={"error"}
                        onClick={backGrid}
                    />

                    {
                        action === tCommon('details') &&
                        <ButtonHLPure
                            nameBtn={t("button.delete")}
                            colorScheme={"error"}
                            onClick={() => toggleDialogDeleteDomain(true)}
                        />
                    }

                    <ButtonHLPure
                        nameBtn={t("button.save")}
                        primary
                        onClick={handleSubmit}
                    />
                </Grid>
            </Grid>
        </Container>
    )
}

export default ConfigurationDomainsAddDomainView